import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from 'material-ui/LinearProgress';
import './bootstrapCard.scss';

const BootstrapCard = ({ children, title, width, minWidth, fullWidth, contentStyle, loading, disabled, titleButtons, margin, padding }) => (
  <div className={ `bootstrap-card__main-container${!fullWidth?' bootstrap-card__main-container_inline':''}` } style={ { width, minWidth, margin } } >
    <div className={ `bootstrap-card__title-container${loading?' blur-content': ''}` }>
      <h2 style={ { margin: 'auto 10px' } }>{ title }</h2>
      <div className={ 'bootstrap-card__button-container' }>
        { titleButtons.map(({ label, onClick }) => <span key={ label.replace(/ /g,"_") } onClick={ onClick }>{ label }</span>) }
      </div>
    </div>
    <div className={ `bootstrap-card__content${loading?' blur-content': ''}` } style={ { contentStyle, padding} }>
      { children }
    </div>
    {
      loading && <div className="bootstrap-card__overlay">
        <LinearProgress mode="indeterminate"/>
      </div>
    }
    {
      !loading && disabled && <div className="bootstrap-card__disabled" />
    }
  </div>
);

BootstrapCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  minWidth: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  margin: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  fullWidth: PropTypes.bool,
  contentStyle: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  titleButtons: PropTypes.array,
  padding: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ])
};

BootstrapCard.defaultProps = {
  width: 'auto',
  minWidth: 'auto',
  fullWidth: true,
  contentStyle: {},
  loading: false,
  disabled: false,
  titleButtons: []
};

export default BootstrapCard;



// WEBPACK FOOTER //
// ./src/shared/components/bootstrapCard/BootstrapCard.js